// Localization config (Jordan)

import { Localization } from '../../../shared/Localization';

import ar from '../../generic/l10n/messages_ar';
import en from '../../generic/l10n/messages_en';

const localization = new Localization('default_jo', ar, [ar, en]);

export default localization;
